import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import { CredentialsService } from '../../services/credentials.service';
import {HasSubscriptions} from '../../components/has-subscriptions';

@Directive({selector: '[appShowAuthed]'})
export class ShowAuthedDirective extends HasSubscriptions implements OnInit {
  constructor(private templateRef: TemplateRef<any>,
              private credentialsService: CredentialsService,
              private viewContainer: ViewContainerRef) {
    super();
  }

  condition: boolean = false;

  ngOnInit() {
    this.addSub(this.credentialsService.isLoggedIn.subscribe((isAuthenticated) => {
      if (isAuthenticated && this.condition || !isAuthenticated && !this.condition) {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    }));
  }

  @Input() set appShowAuthed(condition: boolean) {
    this.condition = condition;
  }
}
